const counterJS = () => {
	const counters = document.querySelectorAll(".item-value");
	const speed = 500;

	const animateCounter = (counter) => {
		const value = +counter.getAttribute("numberTo");
		const data = +counter.innerText;
		const time = value / speed;

		if (data < value) {
			counter.innerText = Math.ceil(data + time);
			requestAnimationFrame(() => animateCounter(counter));
		} else {
			counter.innerText = value;
		}
	};

	const handleIntersection = (entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				animateCounter(entry.target);
			}
		});
	};

	const observer = new IntersectionObserver(handleIntersection, {
		root: null, // Use the viewport as the root
		threshold: 0.5, // Trigger when at least 50% of the element is visible
	});

	counters.forEach((counter) => {
		observer.observe(counter);
	});
};

export { counterJS };
